import { FeaturesRoutingEnum } from '@features/feature-routing-enum';
import { LayoutComponent } from '@features/layouts/layout/layout.component';
import { LoginTokenGuard } from '@features/guards/login-token/login-token.guard';
import { MustBeAuthorizedGuard } from '@wizbii-components/bo-angular-ui';
import { NotLoggedGuard } from '@features/guards/not-logged/not-logged.guard';
import { PageNotFoundComponent } from '@features/errors-pages/page-not-found/page-not-found.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    canActivate: [LoginTokenGuard, NotLoggedGuard, MustBeAuthorizedGuard],
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: FeaturesRoutingEnum.Members, pathMatch: 'full' },
      {
        path: FeaturesRoutingEnum.Dashboard,
        loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.routes),
      },
      {
        path: FeaturesRoutingEnum.Members,
        loadChildren: () => import('./members/members.routes').then((m) => m.routes),
      },
      {
        path: FeaturesRoutingEnum.Firms,
        loadChildren: () => import('./firms/firms.routes').then((m) => m.routes),
      },
      {
        path: FeaturesRoutingEnum.OldRecruiters,
        loadChildren: () => import('./old-recruiters/oldRecruiters.routes').then((m) => m.routes),
      },
      {
        path: FeaturesRoutingEnum.Recruteurs,
        loadChildren: () => import('./recruiters/recruiters.routes').then((m) => m.routes),
      },
      {
        path: FeaturesRoutingEnum.Emails,
        loadChildren: () => import('./emails/email.routes').then((m) => m.routes),
      },
      {
        path: FeaturesRoutingEnum.Offers,
        loadChildren: () => import('./jobs/jobs.routes').then((m) => m.routes),
      },
    ],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
